import { ResponsibleUser } from 'domains/user'

import { protectedApi } from './requester'

export const getResponsibleUsers = (): Promise<ResponsibleUser[]> => {
  return protectedApi.get<ResponsibleUser[]>('/users/responsible').then((response) => response.data)
}

export const getSubordinateUsers = (username: string): Promise<ResponsibleUser[]> => {
  return protectedApi
    .get<ResponsibleUser[]>(`/users/responsible/${username}/subordinates`)
    .then((response) => response.data)
}
